// eslint-disable-next-line no-restricted-imports
import { useTranslation } from 'react-i18next'

import type { TranslationKey } from '../../i18n'

function useTypedTranslation() {
  const { t: originalT, i18n } = useTranslation()

    // Create an overloaded function that returns string by default
    function t(key: TranslationKey): string
    function t(key: TranslationKey, options: any): string
    function t(key: TranslationKey, options?: any) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return originalT(key, options)
    }

    return { t, i18n }
}

export default useTypedTranslation